import { CommonModule } from '@angular/common';
import { Component, input, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BellComponent } from '../svg/bell';
import { HeartComponent } from '../svg/heart';
import { OfferProduct } from '../../models/offer-product.model';

@Component({
  selector: 'app-product-card',
  imports: [CommonModule, RouterModule, BellComponent, HeartComponent],
  standalone: true,
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent {
  @Input() title: string = '';
  @Input() product: OfferProduct = {} as OfferProduct;

  calculateDiscountPercentage(regularPrice: number, discountPrice: number): number {
    if (regularPrice <= 0) {
      throw new Error("Regular price must be greater than zero.");
    }

    const discountAmount = regularPrice - discountPrice;
    const discountPercentage = Math.round((discountAmount / regularPrice) * 100);

    return discountPercentage;
  }

  toDenars(price: number): string {
    return `${price} денари`; // Adjust this function as needed for formatting
  }

  truncateText(text: string | undefined, maxLength: number): string {
    if (!text) {
      return '';
    }
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  }
}